export default __webpack_public_path__ + "images/956822a92a76ae5d65f8fd2da5532aaa.svg";